import { render, staticRenderFns } from "./SubscribedChannels.vue?vue&type=template&id=849d280c&scoped=true&"
import script from "./SubscribedChannels.vue?vue&type=script&lang=js&"
export * from "./SubscribedChannels.vue?vue&type=script&lang=js&"
import style0 from "./SubscribedChannels.vue?vue&type=style&index=0&id=849d280c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "849d280c",
  null
  
)

export default component.exports